module.exports = __webpack_public_path__ + "f25657a9c0ba2787e91f0ba48871d807.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SM.svg
// module id = Lha/
// module chunks = 0